import { Button, Modal, Row } from "antd";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import TableAuditTypes from "../../components/tables/TableAuditTypes/TableAuditTypes";
import FormAuditType, { transformAuditTypeToFormValues } from "../../components/forms/FormAuditType";
import { useLazyFetchPaginatedAuditTypesQuery } from "../../features/api/apiSlice";
import { useCrudAuditType } from "../../features/api/crud/hooks/useCrudAuditType";
import { useModal } from "../PageUsers/useModal";
import { modalProps } from "../../features/modals/modalProps";
import styles from "./PageAuditTypes.module.scss";

const PageAuditTypes: React.FC = () => {
  const [fetchAuditTypes, { data, isFetching }] = useLazyFetchPaginatedAuditTypesQuery();

  const { isModalOpen, modalItemId, onShowModal, onHideModal, onModifyShowModal } = useModal();

  const { createAuditType, isCreating, updateAuditType, isUpdating, onDelete, isDeleting } =
    useCrudAuditType(modalItemId, () => fetchAuditTypes(), onHideModal);

  const formMode = modalItemId ? "update" : "create";
  const modalAuditType = data?.results?.find((a) => a.id === modalItemId);

  return (
    <PageLayout pageContainerClassName={styles.root}>
      <div className={styles.top}>
        <h1>Les types d'audit</h1>
        <Button type="primary" onClick={onShowModal}>
          CrÃ©er un type d'audit
        </Button>
      </div>
      <Row>
        <TableAuditTypes
          data={data}
          fetchData={fetchAuditTypes}
          isLoading={isFetching || isDeleting}
          onModify={onModifyShowModal}
          onDelete={onDelete}
        />
      </Row>
      <Modal
        {...modalProps}
        title={formMode === "create" ? "CrÃ©er un type d'audit" : "Modifier un type d'audit"}
        open={isModalOpen}
        onCancel={onHideModal}
        footer={
          <>
            <Button onClick={onHideModal} disabled={isCreating || isUpdating}>
              Annuler
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              form="form-audit-type"
              loading={isCreating || isUpdating}
            >
              {formMode === "create" ? "Ajouter" : "Mettre Ã  jour"}
            </Button>
          </>
        }
      >
        <br />
        <FormAuditType
          key={modalAuditType?.id ?? "new"}
          onSubmit={formMode === "create" ? createAuditType : updateAuditType}
          defaultValues={transformAuditTypeToFormValues(modalAuditType)}
        />
      </Modal>
    </PageLayout>
  );
};

export default PageAuditTypes;
